import i18n from 'i18n';

export const t = (text: string, options?: object) => i18n.t(text, options);
